// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"195b869a","692":"e8f81957","788":"ff3e68df"}[chunkId] + ".chunk.js";
};